import { MutationTree } from 'vuex';
import {
  IOnboardingState,
  EOnboardingMutation,
} from '@/onboarding-sidebar/store/onboarding.constants';
import { EAbTestingGroup } from '@/enums/ab-testing';

export const mutations: MutationTree<IOnboardingState> = {
  [EOnboardingMutation.OnboardingGroup](state: IOnboardingState, onboardingGroup: EAbTestingGroup) {
    state.onboardingGroup = onboardingGroup;
  },
  [EOnboardingMutation.SetSentFirstDocument](
    state: IOnboardingState,
    hasSentFirstDocument: boolean
  ) {
    state.hasSentFirstDocument = hasSentFirstDocument;
  },
  [EOnboardingMutation.ShowSidebar](state: IOnboardingState, value: boolean) {
    state.showSidebar = value;
  },
};
